angular.module('mercury.modules.time', [
  'mercury.modules.time.clock',
  'mercury.modules.time.compliance',
  'mercury.modules.time.payroll',
  'mercury.modules.time.role',
  'mercury.modules.time.roster',
  'mercury.modules.time.staff'
]);
